import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import MultiCarousel from './MultiCarousel';

const Carousel = forwardRef(({ children, ...rest }, ref) => (
	<div className="Carousel">
		<MultiCarousel ref={ref} {...rest}>
			{children}
		</MultiCarousel>
	</div>
));

Carousel.propTypes = {
	children: PropTypes.oneOfType([ PropTypes.node, PropTypes.arrayOf(PropTypes.node) ]).isRequired
};
export default Carousel;
